"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.LightTheme5_1 = void 0;var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));var _ThemeHelpers = require("../../lib/theming/ThemeHelpers");

var _BasicTheme = require("./BasicTheme");
var _LightTheme5_2 = require("./LightTheme5_0");var _LightTheme5_;

var LightTheme5_1 = exports.LightTheme5_1 = (0, _ThemeHelpers.createTheme)({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {function LightTheme5_1() {return _BasicThemeClassForEx.apply(this, arguments) || this;}(0, _inheritsLoose2.default)(LightTheme5_1, _BasicThemeClassForEx);return (0, _createClass2.default)(LightTheme5_1, null, [{ key: "mobileModalCloseButtonRightPadding", get:




      function get() {
        return this.mobileModalCloseButtonClickArea;
      } }, { key: "mobileModalCloseButtonTopPadding", get:
      function get() {
        return this.mobileModalCloseButtonClickArea;
      } }, { key: "mobileSidePageCloseButtonPadding", get:


      function get() {
        return this.mobileSidePageCloseButtonClickArea;
      } }, { key: "sidePageCloseButtonClickAreaTop", get:
      function get() {
        return this.modalCloseButtonClickAreaTop;
      } }, { key: "sidePageCloseButtonClickAreaBottom", get:
      function get() {
        return this.modalCloseButtonClickAreaBottom;
      } }, { key: "sidePageCloseButtonClickAreaLeft", get:
      function get() {
        return this.modalCloseButtonClickAreaLeft;
      } }, { key: "sidePageCloseButtonClickAreaRight", get:
      function get() {
        return this.modalCloseButtonClickAreaRight;
      } }]);}(_BasicTheme.BasicThemeClassForExtension), _LightTheme5_.modalCloseButtonClickAreaTop = '30px', _LightTheme5_.modalCloseButtonClickAreaBottom = '22px', _LightTheme5_.modalCloseButtonClickAreaLeft = '24px', _LightTheme5_.modalCloseButtonClickAreaRight = '28px', _LightTheme5_.mobileModalCloseButtonClickArea = '22px', _LightTheme5_.sidePageHeaderStickyOffset = '10px', _LightTheme5_.
  mobileSidePageCloseButtonClickArea = '22px', _LightTheme5_.
  sidePageCloseButtonWrapperFixedOffsetTop = '4px', _LightTheme5_.
  sidePageCloseButtonWrapperOffsetTop = '2px', _LightTheme5_),

  prototypeTheme: _LightTheme5_2.LightTheme5_0,
  themeMarkers: [(0, _ThemeHelpers.markThemeVersion)('5.1')]
});